import React from "react";
import SvgIconDPC from "./dpc-svg-icon";

export default class DpcPrintButton extends React.Component {

    print(){
        if(typeof window !== "undefined")
            window.print();
    }

    getTitle = () => {
        if(typeof window !== "undefined")
            return window.location.pathname.split("/")[1] === 'it' ? 'Stampa la pagina' : 'Print this page';
    }

    render(){
        return (
            <div className="print-button d-flex justify-content-end">
                <span>{this.getTitle()}</span>
                <button type="button" aria-label="Stampa la pagina" onClick={() => this.print()}>
                    <SvgIconDPC name='print' />
                </button>
            </div>
        );
    }
}
